module.exports = __webpack_public_path__ + "img/traveller-inactive.2eb41d53.svg";